import React from 'react'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import { ChevronsUpDown } from 'lucide-react'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/gas-components'
import { theme } from '../../../styles/_variables'

const { color } = theme

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          รหัสปั๊มน้ำมัน <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'code',
    sortable: true,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 120,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ชื่อสถานี <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'name',
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.fullname, filter.value),
    sortable: true,
    filterable: true,
    width: 180,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ชื่อทางการ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'officialName',
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.fullname, filter.value),
    sortable: true,
    filterable: true,
    width: 180,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center' style={{ margin: '0 0 0 2px' }}>
        <HeaderLabel>
          บริษัท
        </HeaderLabel>
      </Div>
    ),
    accessor: 'company',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
      key='filter'
      data={[{
        value: 'ALL',
        text: 'ทั้งหมด',
      }, {
        value: 'SHELL',
        text: 'SHELL',
      }, {
        value: 'BANGCHAK',
        text: 'BANGCHAK',
      }, {
        value: 'CALTEX',
        text: 'CALTEX',
      }, {
        value: 'ESSO',
        text: 'ESSO',
      }, {
        value: 'PTT',
        text: 'PTT',
      }, {
        value: 'PT',
        text: 'PT',
      }, {
        value: 'OTHER',
        text: 'OTHER',
      }]}
      handleChange={e => onChange(e)}
      filter={true}
      statusAttr='ทั้งหมด'
      typeNameTh={true}
    />,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 150,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เบอร์โทรศัพท์
        </HeaderLabel>
      </Div>
    ),
    accessor: 'contactnumber',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เลขผู้เสียภาษี
        </HeaderLabel>
      </Div>
    ),
    accessor: 'taxId',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    width: 150,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
